<template>
  <section class="mb-6 pb-5">
    <div class="columns is-justify-content-center">
      <div class="column">
        <header class="mb-6 px-6 pb-6">
          <div class="columns is-justify-content-center">
            <div class="column is-5">
              <h1 class="is-size-1 has-text-weight-semibold has-text-centered">
                {{ title }}
              </h1>
            </div>
          </div>
          <div class="columns is-justify-content-center">
            <div class="column is-6">
              <p class="has-text-centered is-size-3">
                {{ subtitle }}
              </p>
            </div>
          </div>
          <div class="columns is-justify-content-center mt-5">
            <div class="column is-6 has-text-centered">
              <ButtonView
                @click="scrollToCalculator"
                icon-left="cls-arrow-down"
                class="has-text-primary has-border-primary"
              >
                {{ $t('tax.calculator-jump-to') }}
              </ButtonView>
            </div>
          </div>
        </header>
        <section class="has-background-secondary p-6">
          <div class="columns is-justify-content-center m-b-50">
            <div class="column is-3">
              <h2 class="is-size-2 has-text-weight-semibold">
                {{ probateTitle }}
              </h2>
            </div>
            <div class="column is-3">
              <p class="is-size-4">
                {{ probateDescription }}
              </p>
            </div>
          </div>
          <div class="columns is-justify-content-center">
            <div class="column is-3">
              <h2 class="is-size-2 has-text-weight-semibold">
                {{ costTitle }}
              </h2>
            </div>
            <div class="column is-3">
              <p class="is-size-4" v-dompurify-html="costDescription" v-if="costDescription"></p>
              <slot v-else name="costDescription"></slot>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import Lang from '@/modules/core/app/services/Lang';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ProbateTaxDescriptionContent',
  emits: ['scroll-to-calculator'],
  components: { ButtonView },
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    probateTitle: {
      type: String,
      default: () => Lang.t('tax.what-probate-is')
    },
    probateDescription: {
      type: String,
      default: () => Lang.t('tax.simply-typically-settled')
    },
    costDescription: {
      type: String
    },
    costTitle: {
      type: String,
      default: () => Lang.t('tax.what-are-the')
    }
  },
  methods: {
    scrollToCalculator() {
      this.$emit('scroll-to-calculator');
    }
  }
};
</script>

<style scoped>
.is-size-1 {
  font-size: var(--ce-48px) !important;
}
</style>
